// extracted by mini-css-extract-plugin
export default {"row":"KoseckiSummary_row__E8Wmb","table":"KoseckiSummary_table__5i2jG","min120":"KoseckiSummary_min120__D4W93"};